import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ax from "../config";
import { openNotification } from "src/components/helpers/notification";

const initialState = {
  trainerTypes: null,
  clubs: null,
  months: null,
  clubTypes: null,
  users: null,
  scheduleClients: null,
  usersLoading: false,
  trainersList: null,
  managersList: null,
  gyms: null,
  roles: null,
  formViews: null,
  reportTypes: null,
  filterTypes: null,
  paymentSystems: null,
  services: null,
  sheduleTagsLoading: false,
  tags: null
};

export const getTrainerTypes = createAsyncThunk(
  "trainerTypes",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/trainerTypes", {
        params: payload,
      });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getClubs = createAsyncThunk(
  "clubs",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/getClubs", { params: payload });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getMonths = createAsyncThunk(
  "getMonths",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/monthCount", {
        params: payload,
      });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getClubTypes = createAsyncThunk(
  "clubTypes",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/clubTypes", {
        params: payload,
      });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getServices = createAsyncThunk(
  "services",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/getServices", {
        params: payload,
      });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getUsers = createAsyncThunk(
  "getUsers",
  async (payload, { dispatch }) => {
    dispatch(setUsersLoading(true));
    try {
      const { data } = await ax.get("/api/admin/users", { params: payload });
      data && dispatch(setUsersLoading(false));
      return data;
    } catch (error) {
      dispatch(setUsersLoading(false));

      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getScheduleClients = createAsyncThunk(
  "getScheduleClients",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/getScheduleClients", {
        params: payload,
      });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getTrainers = createAsyncThunk(
  "getTrainers",
  async (payload, { dispatch }) => {
    dispatch(setUsersLoading(true));
    try {
      const { data } = await ax.get("/api/admin/employs", { params: payload });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getManagers = createAsyncThunk(
  "getManagers",
  async (payload, { dispatch }) => {
    dispatch(setUsersLoading(true));
    try {
      const { data } = await ax.get("/api/admin/managers", { params: payload });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getGyms = createAsyncThunk(
  "getGyms",
  async (payload, { dispatch }) => {
    dispatch(setUsersLoading(true));
    try {
      const { data } = await ax.get("/api/admin/classes", { params: payload });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getRoles = createAsyncThunk(
  "getRoles",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/roles", { params: payload });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getFormViews = createAsyncThunk(
  "getFormViews",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/formViews", {
        params: payload,
      });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getPaymentSystem = createAsyncThunk(
  "paymentSystem",
  async (payload) => {
    try {
      const { data } = await ax.get("/api/admin/paymentSystems", {
        params: payload,
      });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getReportTypes = createAsyncThunk(
  "getReportTypes",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/reports", { params: payload });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);

export const getFilterTypes = createAsyncThunk(
  "getFilterTypes",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/filters", { params: payload });
      return data;
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
    }
  }
);



const DropDownSlice = createSlice({
  name: "dropDown",
  initialState,
  reducers: {
    setUsersLoading: (state, action) => {
      state.usersLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTrainerTypes.fulfilled, (state, action) => {
      state.trainerTypes = action.payload;
    }),
      builder.addCase(getUsers.fulfilled, (state, action) => {
        state.users = action.payload;
      }),
      builder.addCase(getScheduleClients.fulfilled, (state, action) => {
        state.scheduleClients = action.payload;
      }),
      builder.addCase(getClubs.fulfilled, (state, action) => {
        state.clubs = action.payload;
      }),
      builder.addCase(getMonths.fulfilled, (state, action) => {
        state.months = action.payload;
      }),
      builder.addCase(getClubTypes.fulfilled, (state, action) => {
        state.clubTypes = action.payload;
      }),
      builder.addCase(getTrainers.fulfilled, (state, action) => {
        state.trainersList = action.payload;
      }),
      builder.addCase(getPaymentSystem.fulfilled, (state, action) => {
        state.paymentSystems = action.payload;
      }),
      builder.addCase(getManagers.fulfilled, (state, action) => {
        state.managersList = action.payload;
      }),
      builder.addCase(getGyms.fulfilled, (state, action) => {
        state.gyms = action.payload;
      }),
      builder.addCase(getRoles.fulfilled, (state, action) => {
        state.roles = action.payload;
      }),
      builder.addCase(getFormViews.fulfilled, (state, action) => {
        state.formViews = action.payload;
      });
    builder.addCase(getReportTypes.fulfilled, (state, action) => {
      state.reportTypes = action.payload;
    });
    builder.addCase(getFilterTypes.fulfilled, (state, action) => {
      state.filterTypes = action.payload;
    });
    builder.addCase(getServices.fulfilled, (state, action) => {
      state.services = action.payload;
    });
    
  },
});

export const { setUsersLoading } = DropDownSlice.actions;

export default DropDownSlice.reducer;
